import yup from '../../../config/yup';

export const validateValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('command'),
  type: yup.string().default('validate'),
  action: yup.string().default('VALIDATE').required('Action is required'),
  command: yup
    .string()
    .default('VALIDATE')
    .required('Command is required')
    .matches(
      /^VALIDATE\s+\S+/i,
      "Command must start with 'VALIDATE' followed by at least one word"
    ),
});
